export default "__VITE_ASSET__Cu7F$d$f__"